import { ScrollButtonProps } from 'screens/blaze/Home/components/Catalogue/components/ScrollButton/Types'
import cx from 'classnames'
import Styles from './ScrollButton.module.scss'
import { ChevronLeft } from 'blaze-ui/icons/24'
import { usePreviousButton } from 'components/Carousel/usePreviousButton'

export const PreviousButton = (props: ScrollButtonProps) => {
  const { isFocusVisible, isDisabled, isPressed, buttonProps, buttonRef } = usePreviousButton(props)

  return (
    <button
      ref={buttonRef}
      className={cx(Styles.scrollButton, {
        [Styles.disabled]: isDisabled,
        [Styles.pressed]: isPressed,
        [Styles.focused]: isFocusVisible,
      })}
      disabled={isDisabled}
      aria-label="Next"
      {...buttonProps}
    >
      <ChevronLeft size={24} />
    </button>
  )
}
